import { Navigate, Outlet } from 'react-router-dom';
import { useOnboardingStatus } from '../features/onboarding/onboarding-status';
import { Spinner } from './ui';

/** Wraps the authenticated app shell: sends companies that haven't finished onboarding there. */
export function OnboardingGate() {
  const { isLoading, isComplete } = useOnboardingStatus();

  if (isLoading) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <Spinner label="Carregando" />
      </div>
    );
  }

  if (!isComplete) {
    return <Navigate to="/onboarding" replace />;
  }

  return <Outlet />;
}

/** Wraps /onboarding itself: skip it once the company has already finished it. */
export function RedirectIfOnboarded() {
  const { isLoading, isComplete } = useOnboardingStatus();

  if (isLoading) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <Spinner label="Carregando" />
      </div>
    );
  }
  if (isComplete) return <Navigate to="/licitacoes" replace />;

  return <Outlet />;
}
